import { render, staticRenderFns } from "./BusinessUser.vue?vue&type=template&id=8389825c&scoped=true&"
import script from "./BusinessUser.vue?vue&type=script&lang=js&"
export * from "./BusinessUser.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUser.vue?vue&type=style&index=0&id=8389825c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8389825c",
  null
  
)

export default component.exports